import axios from 'axios';
import Constants from '../constants';
import { ITrendSurvey } from '../models/ITrendSurvey';

export const trendGroupHistoryApi = Constants.SURVEY_BUILDER_SURVEYS_API_URL + '/{surveyId}/survey-trend-groups/history';
export async function get(surveyId: number, trendGroupId: string): Promise<ITrendSurvey[]> {
	const url = trendGroupHistoryApi.replace('{surveyId}', surveyId.toString()) + '/' + trendGroupId;
	const res = await axios.get(url, { headers: { Pragma: 'no-cache' } });
	return res.data;
}
export async function getTrendSurveys(surveyId: number): Promise<ITrendSurvey[]> {
	const url = trendGroupHistoryApi.replace('{surveyId}', surveyId.toString());
	const res = await axios.get(url, { headers: { Pragma: 'no-cache' } });
	return res.data;
}

export const surveyTrendGroupsApi = Constants.SURVEY_BUILDER_SURVEYS_API_URL + '/{surveyId}/survey-trend-groups';
export async function update(surveyId: number, selectedTrendGroupId: string): Promise<string> {
	const res = await axios.put(
		surveyTrendGroupsApi.replace('{surveyId}', surveyId.toString()) + '?selectedTrendGroupId=' + selectedTrendGroupId,
	);
	return res.data;
}
export async function getTrendGroupId(surveyId: number): Promise<string> {
	const res = await axios.get(surveyTrendGroupsApi.replace('{surveyId}', surveyId.toString()), { headers: { Pragma: 'no-cache' } });
	return res.data;
}
